module.exports = __webpack_public_path__ + "img/Education-low.2f43df5f.jpg";